export enum EN_欧莱雅_BRANCH_NAME {
  欧莱雅 = '欧莱雅',
}
